import { Link } from "react-router-dom";

export default function CtaBand() {
  return (
    <section className="bg-ink py-24 text-linen">
      <div className="mx-auto max-w-4xl px-6 text-center">
        <div className="overline mb-4" style={{ color: "#c9b8a8" }}>Reach out</div>
        <h2 className="mx-auto max-w-2xl font-serif text-4xl leading-tight sm:text-5xl">
          We'll meet you <span className="italic" style={{ color: "#d9b48f" }}>where you are.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl font-sans text-base leading-relaxed text-linen/70">
          Share a few details and a care coordinator will call or email within one business day. Everything is HIPAA-protected and confidential.
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Link to="/new-patient" data-testid="cta-enroll" className="rounded-full bg-linen px-8 py-3.5 font-sans text-sm text-ink transition-colors hover:bg-white">
            Enroll as a new patient
          </Link>
          <Link to="/contact" data-testid="cta-visit" className="rounded-full border border-linen/30 px-8 py-3.5 font-sans text-sm text-linen transition-colors hover:bg-linen/10">
            Visit the clinic
          </Link>
        </div>
      </div>
    </section>
  );
}
